import { useState, useEffect, useMemo } from "react";

/**
 * Custom React hook to determine the appropriate graph height based on the window width,
 * print mode, and legend configuration.
 *
 * @param {boolean} isPrint - Indicates if the graph is being rendered for print.
 * @param {boolean} [areLegendsConstant=false] - Optional. Determines if the legends are constant (affects height for certain widths).
 * @returns {number} The calculated height for the graph in pixels.
 *
 * @example
 * const graphHeight = useGraphHeight(isPrint, areLegendsConstant);
 */
const useGraphHeight = (isPrint, areLegendsConstant = false) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const graphHeight = useMemo(() => {
    if (isPrint) return 400;
    return windowWidth < 1194
      ? 350
      : windowWidth < 1765
      ? areLegendsConstant
        ? 350
        : 350
      : 470;
  }, [windowWidth, isPrint]);

  return graphHeight;
};

export default useGraphHeight;
